import { Dropdown } from "react-bootstrap";
import { datagridColumns } from "../utils/datagridCommon";
import DateUtil from "../utils/DateUtil";
import { pivotGroupByOptions } from "../utils/misc";
import StateHelper from "../utils/StateHelper";
import { PageState, PivotIds } from "../utils/types";
import dayjs from "../utils/dayjs";

function Pivot({ fields, pivotFieldSelected, pivotGroupBySelected, onPivotChange} : any) {

  const pageState:PageState = StateHelper.getPageState();
  const datesRangeInDays = DateUtil.getDatesRangeInDays(pageState.dateStart, pageState.dateEnd);

  let currentDatesToString:string;
  switch ( pageState.dateMode ) {
    case "days":
      if (datesRangeInDays === 1) {
        currentDatesToString = " (1 day)";
      } else {
        currentDatesToString = " (" + datesRangeInDays + " days)";
      }
      break;
    case "weeks":
      currentDatesToString = " (" + (Math.abs(dayjs.utc(pageState.dateStart).diff(pageState.dateEnd, "weeks")) + 1) + " weeks)";
      break;
    case "months":
      currentDatesToString = " (" + (Math.abs(dayjs.utc(pageState.dateStart).diff(pageState.dateEnd, "months")) + 1) + " months)";
      break;
  } 

  const statsFields = [
    {
      id: 'All',
      name: 'All stats (remove groupbys)'
    },
    ...fields
  ];
  function onFieldSelectedCHange(newPivotFieldSelected: any) {
    const newPivotGroupBySelected = pivotGroupBySelected.id === PivotIds.off ? pivotGroupByOptions.find((p) => p.id === PivotIds.current) : pivotGroupBySelected;
    onPivotChange(newPivotFieldSelected, newPivotGroupBySelected);
  }

  return (
    <Dropdown>
      <Dropdown.Toggle style={{ whiteSpace: "normal", fontSize: 12, textAlign: "left" }} size="sm" variant="outline-primary" id="dropdown-basic">
        Pivot by {pivotGroupBySelected && pivotGroupBySelected.id !== pivotGroupByOptions[0].id ? "(" + (pivotFieldSelected === "All" ? "All" : datagridColumns.get(pivotFieldSelected).name) + ")" : "..."}
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ margin: 0 }}>
        <Dropdown.Header style={{ fontSize: 12, fontWeight: 600 }}>Group By Value</Dropdown.Header>

        {
          pivotGroupByOptions.map((groupBy:any) => {
            return (
              <Dropdown.Item
                style={{ fontSize: 11 }} 
                key={groupBy.id} 
                eventKey={groupBy.id}
                active={pivotGroupBySelected.id === groupBy.id}
                onClick={() => onPivotChange(pivotFieldSelected, groupBy)}
              >
                <div className="form-check d-inline">
                  <input className="form-check-input"
                    type="radio"
                    name="groupBy"
                    id={"groupBy-" + groupBy.id} 
                    style= {{ top: "-3px", cursor: "pointer" }}
                    value={groupBy.id}
                    onChange={(e) => e.preventDefault()}
                    checked={pivotGroupBySelected.id === groupBy.id}
                  />
                  {
                    groupBy.id !== PivotIds.current ? groupBy.name : groupBy.name + currentDatesToString
                  }
                </div>
              </Dropdown.Item>
            );
          })
        }

        <Dropdown.Divider />
        <Dropdown.Header style={{ fontSize: 12, fontWeight: 600 }}>Stats Value</Dropdown.Header>
        
        {
          statsFields.map((field:any) => {
            return (
              <Dropdown.Item
                style={{ fontSize: 11 }} 
                key={field.id} 
                eventKey={field.id}
                active={pivotGroupBySelected.id !== PivotIds.off && pivotFieldSelected === field.id}
                onSelect={() => onFieldSelectedCHange(field.id)}
              >
                <div className="form-check">
                  <input className="form-check-input"
                    type="radio"
                    name="statField"
                    id={"statField-" + field.id} 
                    key={pivotFieldSelected + field.id} 
                    style= {{ top: "-3px", cursor: "pointer" }}
                    value={field.id}
                    onChange={(e) => e.preventDefault()}
                    checked={pivotGroupBySelected.id !== PivotIds.off && pivotFieldSelected === field.id}
                  />
                  {field.name}
                </div>
              </Dropdown.Item>
            );
          })
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default Pivot;